export const bulletinContentInitialState = {
  sort: {
    news: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    instagram: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    instagramStories: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    instagramComment: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    twitter: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    telegram: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    newspaper: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    nativePlatforms: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    linkedin: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
    virasty: {
      sortBy: {
        selected: 'defaultSort',
        order: 'desc',
      },
    },
  },
  bulletin: {
    data: {},
    loading: false,
    error: null,
  },
  contents: {
    data: [],
    loading: true,
    error: null,
  },
  sortRequest: {
    loading: false,
    error: null,
  },
  selectedContents: [],
  sortable: false,
  kioskNewspapers: {
    data: [],
    loading: false,
    error: null,
  },
};
